<script setup lang="ts">
import { defineProps, PropType } from 'vue'

defineProps({
  visible: {
    type: Boolean as PropType<boolean>,
    default: true,
  },
})
</script>

<template>
  <div :class="{ container: true, visible }">
    <ul>
      <slot></slot>
    </ul>
  </div>
</template>

<style scoped>
.container {
  display: none;
  position: absolute;
  right: -312px;
  top: 0;
  width: 300px;
  background-color: var(--primary-color);
  border-radius: 6px;
  z-index: 1000;
  overflow: hidden;
}

.container.visible {
  display: inherit;
}

.container p {
  margin: 0;
}

ul {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
}

li {
  transition: 0.3s all;
  padding: 12px 16px;
  width: 100%;
  display: flex;
  gap: 16px;
  justify-content: flex-start;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
  color: #86a6d9;
}

h3 {
  color: #f5f5f5;
}

li:hover {
  background-color: #3e5880;
  color: #f5f5f5;
}

li h3 {
  font-size: inherit;
  font-weight: 700;
}
</style>
